/*
 * @Author: along longwang6@163.com
 * @Date: 2025-06-14 16:57:00
 * @LastEditors: along longwang6@163.com
 * @LastEditTime: 2025-06-17 15:00:42
 * @FilePath: /ehr-web/src/store/modules/HunterUser.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { makeAutoObservable } from 'mobx';

interface UserInfo {
  hunterId?: number;
  name?: string;
  // 其他用户信息字段
}

export default class UserHunterStore {
  userInfo: UserInfo | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setUserInfo(info: UserInfo) {
    this.userInfo = info;
    // 可选：将用户信息保存到 localStorage
    localStorage.setItem('userHunterInfo', JSON.stringify(info));
  }

  clearUserInfo() {
    this.userInfo = null;
    localStorage.removeItem('userHunterInfo');
  }

  // 初始化时从 localStorage 恢复数据
  initUserInfo() {
    const stored = localStorage.getItem('userHunterInfo');
    if (stored) {
      this.userInfo = JSON.parse(stored);
    }
  }
}

// export const userStore = new UserStore();
